exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-51c13897] .el-card__header {\n  background: #f5f7fa;\n}\n.info[data-v-51c13897] {\n  color: #aaa8a8;\n}\n.card-header[data-v-51c13897] {\n  height: 40px;\n  line-height: 40px;\n}\n.container .subtitle[data-v-51c13897] {\n  margin-top: 15px;\n  font-size: 12px;\n  color: #909399;\n}\n", ""]);

// exports
